<template>
  <v-card>
    <v-col>
      <p class="text-body-2 mb-0">
        CUPP performs unsupervised clustering of proteins and fast annotation of
        enzymes including carbohydrate-active, proteases and sulfatases giving
        enzyme family, subfamily and EC function from conserved peptide
        patterns.
      </p>
    </v-col>
  </v-card>
</template>

<script>
export default {
  name: "SubmitInfoCard",
};
</script>

<style></style>
